export const USERNAME_MIN_LENGTH = 3;
export const USERNAME_MAX_LENGTH = 30;

/** Characters accepted in a username: lowercase letters, digits, underscore, hyphen. */
const ALLOWED_CHARS = /^[a-z0-9_-]+$/;
const DISALLOWED_CHARS = /[^a-z0-9_-]/g;

export const USERNAME_RULES_HINT =
  'Lowercase letters, numbers, underscores (_), and hyphens (-) only — not an email address';

/**
 * Strips everything that is not an accepted username character. Applied on every
 * keystroke/paste so the field can never hold an email, a slash, whitespace or an
 * accented/non-ASCII character. Usernames are lower-cased because the backend
 * lower-cases the Cognito username when it keys user data.
 */
export const sanitizeUsername = (value: string): string =>
  value
    .toLowerCase()
    .replace(DISALLOWED_CHARS, '')
    .slice(0, USERNAME_MAX_LENGTH);

/** Returns an error message for an invalid username, or null when it is valid. */
export const validateUsername = (username: string): string | null => {
  if (!username) {
    return 'Please enter a username';
  }
  if (username.length < USERNAME_MIN_LENGTH) {
    return `Username must be at least ${USERNAME_MIN_LENGTH} characters long`;
  }
  if (username.length > USERNAME_MAX_LENGTH) {
    return `Username must be at most ${USERNAME_MAX_LENGTH} characters long`;
  }
  if (!ALLOWED_CHARS.test(username)) {
    return 'Username may only contain lowercase letters, numbers, underscores (_), and hyphens (-)';
  }
  if (!/^[a-z0-9]/.test(username) || !/[a-z0-9]$/.test(username)) {
    return 'Username must start and end with a letter or number';
  }
  return null;
};
